import styled from 'styled-components';
import { useState } from 'react';
import { WaringModal } from '../../modal/WaringModal';
import { ImageUtils } from '../../../utils/ImageUtils';
import { goToTournament } from '../../../utils';
import { infoStore } from '../../../store/infoStore';

export const Ticket = ({
  goMainEventTab,
  isActiveTicket,
  goOnlineTab,
}: {
  goMainEventTab: () => void;
  isActiveTicket: boolean;
  goOnlineTab: () => void;
}) => {
  const { info } = infoStore();
  const [showWarningModal, setShowWarningModal] = useState(false);

  return (
    <>
      <Container>
        <ImgContainer>
          <QuestionIcon onClick={() => setShowWarningModal(true)} />
          <TicketImg
            src={isActiveTicket ? ImageUtils.ParticipateInfoActive : ImageUtils.ParticipateInfo}
            alt={'ParticipateInfoActive'}
          />
        </ImgContainer>
        <CountContainer>
          <TicketTop>
            <CountCnt>
              {info.ticketCnt}
              <CountUnit>장</CountUnit>
            </CountCnt>
            <RemainContainer>
              <RemainText>남은 메인 이벤트 참가 티켓</RemainText>
            </RemainContainer>
            <RemainSubText>
              참가 티켓은 <span>10 TO 1</span> 방식으로 지급되며,
              <br />
              모두 지급되면 새틀라이트가 조기 종료됩니다.
            </RemainSubText>
          </TicketTop>

          <TicketBottom>
            {isActiveTicket ? (
              <>
                <CongratsText>축하합니다!</CongratsText>
                <CongratsSubText>
                  새틀라이트 티켓을 총 <span>{(info?.ticketNo || []).length}장</span> 획득했어요.
                  <br /> 메인 이벤트 탭을 확인해주세요!
                </CongratsSubText>
              </>
            ) : (
              <>
                <NeedTicketSubText>메인 이벤트 참가 티켓 획득 여부</NeedTicketSubText>
                <NeedTicketText>참가 티켓을 아직 획득하지 못했습니다.</NeedTicketText>
                <NeedTicketSubText>새틀라이트를 통해 티켓을 획득해주세요!</NeedTicketSubText>
              </>
            )}
          </TicketBottom>
        </CountContainer>
      </Container>
      <BottomTabContainer>
        {isActiveTicket ? (
          <GoMainEventBtn onClick={goMainEventTab}>메인이벤트 참가 안내 확인하기</GoMainEventBtn>
        ) : (
          <>
            <CheckParticipateBtn onClick={goOnlineTab}>
              새틀라이트
              <br />
              참가 방법
            </CheckParticipateBtn>
            <GoTournamentBtn onClick={goToTournament}>새틀라이트 참가하기</GoTournamentBtn>
          </>
        )}
      </BottomTabContainer>
      <WaringModal visible={showWarningModal} close={() => setShowWarningModal(false)} />
    </>
  );
};

const ImgContainer = styled.div`
  position: relative;
`;

const TicketImg = styled.img`
  width: 350px;
`;

const Container = styled.div`
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding-bottom: 130px;
`;

const CountContainer = styled.div`
  position: absolute;
  top: 10px;
  width: 100%;
  text-align: center;
`;

const TicketTop = styled.div`
  height: 225px;
`;
const TicketBottom = styled.div`
  height: 110px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const RemainContainer = styled.div`
  margin: 0 auto;
  margin-bottom: 9px;

  border-top: 1.5px solid rgba(0, 0, 0, 0.5);

  background: rgba(0, 0, 0, 0.1);

  padding-top: 2px;
  width: 200px;
  height: 29px;
`;

const RemainText = styled.h3`
  font-weight: 800;
  letter-spacing: -0.02em;

  color: rgba(0, 0, 0, 0.7);

  font-size: 16px;
  line-height: 22px;
`;

const RemainSubText = styled.h4`
  letter-spacing: -0.03em;
  color: rgba(0, 0, 0, 0.5);
  font-weight: 500;

  span {
    font-weight: 800;
  }
  font-size: 14px;
  line-height: 20px;
`;

const CongratsText = styled.h3`
  font-weight: 900;
  letter-spacing: -0.02em;

  color: #d2006d;

  margin-bottom: 5px;
  font-size: 24px;
  line-height: 30px;
`;

const CongratsSubText = styled.h4`
  font-weight: 600;
  letter-spacing: -0.02em;

  color: #d50087;
  font-size: 17px;
  line-height: 22px;

  span {
    font-weight: 900;
    text-decoration: underline;
    color: black;
  }
`;

const CountCnt = styled.p`
  font-weight: bold;

  font-size: 96px;
  line-height: 111px;
`;

const CountUnit = styled.span`
  font-size: 24px;
  line-height: 32px;
`;

const QuestionIcon = styled.div`
  position: absolute;
  cursor: pointer;
  z-index: 1;
  background-image: url(${ImageUtils.QuestionIcon});

  width: 25px;
  height: 25px;
  right: 10px;
  top: 20px;
  background-size: contain;
`;

const BottomTabContainer = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 10;
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
`;

const GoMainEventBtn = styled.button`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 100%;
  left: 0;
  cursor: pointer;
  height: 70px;
  background-color: #b60058;

  font-weight: 900;
  font-size: 21px;
  line-height: 28px;
  letter-spacing: -0.04em;

  color: #ffffff;
`;

const NeedTicketText = styled.h3`
  font-weight: 600;
  letter-spacing: -0.02em;

  color: #000000;

  font-size: 18px;
  line-height: 24px;
`;
const NeedTicketSubText = styled.h4`
  letter-spacing: -0.02em;

  color: rgba(0, 0, 0, 0.5);

  font-size: 15px;
  line-height: 24px;
`;

const CheckParticipateBtn = styled.button`
  height: 70px;
  width: 30%;
  left: 0;
  background-color: transparent;
  border: none;
  cursor: pointer;
  background-color: #a91f52;

  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 18px;

  color: #ffffff;
`;

const GoTournamentBtn = styled.button`
  left: 30%;
  height: 70px;
  width: 70%;
  cursor: pointer;
  background-color: #7e0f45;

  font-weight: 900;
  font-size: 21px;
  line-height: 28px;
  letter-spacing: -0.04em;
  color: #ffffff;
`;
